import { Routes, Route } from "react-router-dom";
import { ToastContainer} from 'react-toastify';
import { DetectProvider } from "./contexts/DetectContext";
import { useDispatch, useSelector } from "react-redux"; // Add this
import { useEffect } from "react"; // Add this
import { verifyToken } from "./features/authSlice"; // Add this

import HomePage from "./pages/HomePage";
import ImageDetection from "./pages/ImageDetection";
import LiveDetection from "./pages/LiveDetection";
import DataCollection from "./pages/DataCollection";
import Login from "./pages/Login";
import PrivateRoute from "./components/PrivateRoute";
import MapResults from "./pages/MapResults";


function App() {
  const dispatch = useDispatch();
  const { token, tokenVerified } = useSelector((state) => state.auth);

  useEffect(() => {
    if (token && !tokenVerified) {
      dispatch(verifyToken());
    }
  }, [token, tokenVerified, dispatch]);

  return (
    
      <DetectProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute validRole={["admin", "manager", "user"]}>
                <HomePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/image-detection"
            element={
              <PrivateRoute validRole={["admin"]}>
                <ImageDetection />
              </PrivateRoute>
            }
          />
          <Route
            path="/live-detection"
            element={
              <PrivateRoute validRole={["admin"]}>
                <LiveDetection />
              </PrivateRoute>
            }
          />
          <Route
            path="/data-collection"
            element={
              <PrivateRoute validRole={["admin", "manager", "user"]}>
                <DataCollection />
              </PrivateRoute>
            }
          />
          <Route
            path="/map-results"
            element={
              <PrivateRoute validRole={["admin","manager"]}>
                <MapResults />
              </PrivateRoute>
            }
          />
        </Routes>
        <ToastContainer />
      </DetectProvider>
    
  );
}

export default App;
